import { useState } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router';
import { useStore } from '../store';
import { Avatar } from './Avatar';
import { FeedbackButton } from './Feedback';
import { cls } from '../lib/util';

const NAV = [
  ['/', '🏠', 'Home'], ['/battle', '⚔️', 'Battle'], ['/collection', '🎴', 'Collection'], ['/packs', '🎁', 'Packs'], ['/friends', '👥', 'Friends'],
  ['/store', '🛒', 'Store'], ['/upload', '📸', 'Upload cards'], ['/leaderboard', '🏆', 'Leaderboard'], ['/learn', '📖', 'How to play'], ['/profile', '🙂', 'Profile'],
] as const;
const TABS = [['/', '🏠', 'Home'], ['/battle', '⚔️', 'Battle'], ['/collection', '🎴', 'Cards'], ['/packs', '🎁', 'Packs'], ['/friends', '👥', 'Mates']] as const;
const TITLES: Record<string, string> = { '/': 'Home', '/battle': 'Battle', '/collection': 'Collection', '/packs': 'Packs', '/friends': 'Friends', '/store': 'Store', '/upload': 'Upload physical cards', '/leaderboard': 'Leaderboard', '/learn': 'How to play', '/profile': 'Profile', '/admin': 'Admin' };

export function Shell() {
  const { user, logout, socketStatus } = useStore();
  const loc = useLocation();
  const [menu, setMenu] = useState(false);
  if (!user) return null;
  const isAdmin = !!user.staff;
  const nav = [...NAV, ...(isAdmin ? [['/admin', '🛠️', 'Admin'] as const] : [])];
  return (
    <div className="shell">
      <nav className="rail" aria-label="Main">
        <Link className="logo" to="/"><img src="/logo.png" alt="Gooflord" /></Link>
        {nav.map(([to, ic, n]) => <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => cls('nav', isActive && 'on')}><span aria-hidden="true">{ic}</span> {n}</NavLink>)}
        <div className="spacer" />
        <div className="who"><Avatar u={user} /><div><b>{user.display_name}</b><small>{user.rank} · {(user.staff?.role ?? user.role).replace('_', ' ')}</small></div></div>
        <button className="btn ghost sm" onClick={logout}>Sign out</button>
      </nav>
      <main>
        <div className="topbar">
          <h1>{TITLES[loc.pathname] ?? 'Gooflord'}</h1>
          <div className="row">
            {socketStatus !== 'open' && <span className="pill warn" title="Reconnecting to the game server">{socketStatus === 'connecting' ? 'connecting…' : 'offline'}</span>}
            <Link className="credits" to="/profile" aria-label={`${user.credits} credits`}>🪙 {user.credits}</Link>
            <button className="btn ghost sm menu-btn" aria-label="More" onClick={() => setMenu(!menu)}>☰</button>
          </div>
        </div>
        {menu && <div className="menu-sheet" onClick={() => setMenu(false)}>{nav.map(([to, ic, n]) => <Link key={to} to={to}><span aria-hidden="true">{ic}</span> {n}</Link>)}<button className="btn ghost sm" onClick={logout}>Sign out</button></div>}
        {!user.email_verified && loc.pathname === '/' && <VerifyBanner />}
        <Outlet />
        <footer className="foot"><Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link> · <Link to="/learn">Rules</Link> · Gooflord beta</footer>
      </main>
      <nav className="tabs" aria-label="Sections">
        {TABS.map(([to, ic, n]) => <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => cls(isActive && 'on')}><span aria-hidden="true">{ic}</span>{n}</NavLink>)}
      </nav>
      <FeedbackButton />
    </div>
  );
}

function VerifyBanner() {
  const { notify } = useStore();
  const [sent, setSent] = useState(false);
  return (
    <div className="note warn-note">
      Verify your email to unlock trades and turn notifications. {sent ? 'Sent — check your inbox.' : <button className="btn xs" onClick={async () => { const { post } = await import('../lib/api'); try { await post('/api/auth/verify/resend'); setSent(true); } catch (e) { notify((e as Error).message, { kind: 'error' }); } }}>Resend email</button>}
    </div>
  );
}
